import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AdminAuthProvider } from './contexts/AdminAuthContext';
import Receipts from './pages/Receipts';

const RebuildProtocol = lazy(() => import('./pages/RebuildProtocol'));

export default function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/products/rebuild-protocol"
          element={
            <Suspense fallback={<div className="min-h-screen bg-[#0B0B0B]" />}>
              <RebuildProtocol />
            </Suspense>
          }
        />
        <Route
          path="/*"
          element={
            <ThemeProvider>
              <AdminAuthProvider>
                <Receipts />
              </AdminAuthProvider>
            </ThemeProvider>
          }
        />
      </Routes>
    </Router>
  );
}
